import { render, staticRenderFns } from "./prakerja.vue?vue&type=template&id=1f4ed21d&scoped=true"
import script from "./prakerja.vue?vue&type=script&lang=js"
export * from "./prakerja.vue?vue&type=script&lang=js"
import style0 from "./prakerja.vue?vue&type=style&index=0&id=1f4ed21d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ed21d",
  null
  
)

export default component.exports